import { Col } from 'reactstrap';
import BaseLoader from './parts/BaseLoader';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import CourseHistory from './CourseHistory';
import { TranslationsKeys } from '../../../../../../../locales/translations';

interface GradesHistoryProps {
  studyPlanEnrollmentId: string | undefined;
}

export default function GradesHistory({
  studyPlanEnrollmentId,
}: GradesHistoryProps) {
  const { t } = useTranslation(TranslationsKeys.STUDENT_FILE_ACADEMIC_HISTORY);
  const texts = useMemo(
    () => ({
      history: {
        generalAverage: t(
          `curriculumProgressStudent.history.generalPassedAverage`,
        ),
        coursesValidated: t(
          `curriculumProgressStudent.history.coursesValidated`,
        ),
        noCourses: t(`curriculumProgressStudent.history.noCourses`),
        download: {
          button: t(`curriculumProgressStudent.history.downloadHistory`),
          failed: t(`curriculumProgressStudent.history.downloadFailed`),
          success: t(`curriculumProgressStudent.history.downloadSuccess`),
        },
      },
    }),
    [t],
  );

  if (!studyPlanEnrollmentId) {
    return <div>{t('noStudyPlanEnrollmentId')}</div>;
  }

  return (
    <BaseLoader studyPlanEnrollmentId={studyPlanEnrollmentId}>
      {(data) => (
        <Col className="mt-4 px-0">
          <CourseHistory
            coursesValidated={data.history.coursesValidated}
            periods={data.history.periods}
            generalAverage={data.history.generalAvg}
            studyPlanEnrollmentId={+studyPlanEnrollmentId}
            texts={texts.history}
          />
        </Col>
      )}
    </BaseLoader>
  );
}
